<template>
  <basicContainer>
    <div class="announcementManage">
      <!-- 主数据表 -->

      <easyCruds ref="mainTable" :tableInfo="mainTable" @mainTableReload="mainTableReload"
        @beforeEditFunctionName="beforeEditFunctionName" @beforeViewFunctionName="beforeViewFunctionName"
        @beforeAddFunctionName="beforeAddFunctionName" @addRow="addRow" @reloadTable="reloadTable"
        @deleteRows="deleteRows" @editRow="editRow">
        <template slot="appNameForm" slot-scope="{easyFormInfo,disabled,data,label,prop}">
          <el-input v-model="data[prop]" placeholder="请输入内容" @blur="appNameChange(data[prop],data)"></el-input>
        </template>

        <template slot="yyjjForm" slot-scope="{easyFormInfo,disabled,data,label,prop}">
          <quill-editor style="height:300px;" v-model="fwb.content" v-loading="loading" element-loading-text="附件上传中"
            ref="QuillEditor" :options="fwb.editorOption"></quill-editor>
          <input class="el-upload" type="file" @change="toUploadEnclosure($event)" />
        </template>

        <template slot="iconsForm" slot-scope="{easyFormInfo,disabled,data,label,prop}">
          <img :src="tbSrc" alt class="tbImg" />
        </template>

        <template slot="uploadTbForm" slot-scope="{easyFormInfo,disabled,data,label,prop}">
          <el-form :inline="true" ref="downloadView" :model="uploadView.form" label-suffix=":">
            <el-col :span="24" ref="uploadViewData">
              <input type="file" @change="toUploadFile($event,data)" ref="inputfile" />
            </el-col>
          </el-form>
        </template>
        <template slot="pcUrlForm" slot-scope="{easyFormInfo,disabled,data,label,prop}">
          <el-input type="text" ref="pcUrlInput" placeholder="请输入PC端URL" v-model="data[prop]" :value="data[prop]"
            :disabled="readonly"></el-input>
        </template>

        <template slot="ssflForm" slot-scope="{row}" :data="objData">
          <span v-for="item in objData" :key="item.value">
            <template v-if="item.value === row.ssfl">{{ item.label }}</template>
          </span>
        </template>

        <template slot="yyflForm" slot-scope="{row}" :data="yyflResult">
          <span v-for="item in yyflResult" :key="item.value">
            <template v-if="item.value === row.yyfl">{{ item.label }}</template>
          </span>
        </template>

        <template slot="yylxForm" slot-scope="{row}" :data="yylxResult">
          <span v-for="item in yylxResult" :key="item.value">
            <template v-if="item.value === row.yylx">{{ item.label }}</template>
          </span>
        </template>

        <template slot="sfqyForm" slot-scope="{row}">
          <template v-if="row.sfqy === '1'">是</template>
          <template v-if="row.sfqy === '2'">否</template>
        </template>

        <template slot="blfsForm" slot-scope="{row}" :data="blfsData">
          <span v-for="item in blfsData" :key="item.value">
            <template v-if="item.value === row.blfs">{{ item.label }}</template>
          </span>
        </template>

        <template slot="ssbmForm" slot-scope="{row}" :data="ssbmData">
          <span v-for="item in ssbmData" :key="item.id">
            <template v-if="item.id === row.ssbm">{{ item.name }}</template>
          </span>
        </template>

        <template slot="fztjForm" slot-scope="{row}" :data="ssbmData">
          <span v-for="item in ssbmData" :key="item.id">
            <template v-if="item.id === row.ssbm">{{ item.name }}</template>
          </span>
        </template>

        <template slot="appKeyForm" slot-scope="{row}" :data="appKeysResult">
          <span v-for="item in appKeysResult" :key="item.value">
            <template v-if="item.value === row.appKey">{{ item.label }}</template>
          </span>
        </template>
      </easyCruds>
    </div>
  </basicContainer>
</template>

<script>
import { RESOURSE_CONFIG } from '@/page/config/base_config'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { toolbarOptions } from '@/portal/other/applicationPublishing/quillExtend'

Vue.use(VueQuillEditor)
export default {
  data() {
    return {
      icons: '', // 用于存储图片路径
      loading: false,
      fileName: '',
      content: '',
      yyflResult: [],
      yylxResult: [],
      ssbmResult: [],
      fztjResult: [],
      fwdxResult: [],
      appKeysResult: [],
      ssbmData: '',
      blfsData: '',
      objData: '',
      zyID: '',
      zyzID: '',
      userInfo: '',
      uploadView: {
        show: false,
        form: {
          excelTemplateType: '',
          fileName: ''
        }
      },
      uploadViewData: {
        label: '上传文件'
      },
      readonly: false,
      obj: {},
      data: [],
      flag: false,
      fileList: [{ name: '', url: '/base/images/index/zsxt.png' }],
      tbSrc: '',
      tbCode: '',
      fwb: {
        slotName: 'tableForAdd',
        content: '',
        editorOption: {
          theme: 'snow',
          modules: {
            toolbar: {
              container: toolbarOptions, // 工具栏
              handlers: {
                upload: function (value) {
                  if (value) {
                    document.querySelector('.el-upload').click()
                  }
                }
              }
            }
          }
        }
      },

      mainTable: {
        buttonSetting: {
          allowAdd: true,
          beforeAddFunctionName: 'beforeAddFunctionName',
          beforeViewFunctionName: 'beforeViewFunctionName',
          addButtonArray: [
            {
              clickEvent: 'addRow',
              type: 'primary',
              buttonName: '新增',
              validate: true
            }
          ],
          allowEdit: true,
          beforeEditFunctionName: 'beforeEditFunctionName',
          editButtonArray: [
            {
              clickEvent: 'editRow',
              type: 'primary',
              buttonName: '保存编辑',
              validate: false
            }
          ],
          deleteFunctionName: 'deleteRows',
          allowDelete: true,
          allowMoreDelete: false,
          allowView: true
        },
        header: {
          title: '应用发布管理'
        },
        table: {
          loading: false,
          height: 550,
          stripe: true,
          conditionLabelWidth: 'auto',
          selection: false,
          index: true,
          columns: [
            {
              prop: 'id',
              label: 'ID',
              isSearchCondition: false,
              type: 'select',
              rows: 5,
              span: 12,
              showInTable: false,
              view: [false, false, false],
              dicData: []
            },
            {
              prop: 'ssfl',
              label: '所属分类',
              slotName: 'ssflForm',
              isSearchCondition: true,
              type: 'select',
              rows: 5,
              span: 12,
              required: true,
              dicData: []
            },
            {
              prop: 'yyfl',
              label: '应用分类',
              slotName: 'yyflForm',
              isSearchCondition: true,
              type: 'select',
              rows: 5,
              span: 12,
              required: true,
              showInTable: true,
              dicData: []
            },
            {
              prop: 'appName',
              label: '应用名称',
              isSearchCondition: true,
              type: 'input',
              span: 12,
              required: true
            },

            {
              prop: 'pcUrl',
              label: 'PC端URL',
              isSearchCondition: false,
              type: 'input',
              span: 12,
              formslot: true,
              showInTable: false
            },
            {
              prop: 'sjUrl',
              label: '手机端URL',
              isSearchCondition: false,
              type: 'input',
              showInTable: false,
              span: 12
            },
            {
              prop: 'blfs',
              label: '办理方式',
              slotName: 'blfsForm',
              isSearchCondition: false,
              type: 'select',
              showInTable: true,
              required: true,
              span: 12,
              dicData: []
            },
            {
              prop: 'yylx',
              label: '应用类型',
              slotName: 'yylxForm',
              isSearchCondition: false,
              type: 'select',
              required: true,
              span: 12,
              dicData: []
            },
            {
              prop: 'bldd',
              label: '办理地点',
              isSearchCondition: false,
              type: 'input',
              showInTable: false,
              span: 12
            },
            {
              prop: 'szm',
              label: '首字母',
              isSearchCondition: false,
              type: 'input',
              required: false,
              showInTable: false,
              span: 12,
              view: [false, false, false]
            },
            {
              prop: 'ywsx',
              label: '英文缩写',
              isSearchCondition: false,
              type: 'input',
              showInTable: false,
              span: 12,
              required: false
            },
            {
              prop: 'gjz',
              label: '关键字',
              isSearchCondition: false,
              type: 'input',
              showInTable: false,
              span: 12,
              required: true
            },
            {
              prop: 'jzfs',
              label: '加载方式',
              isSearchCondition: false,
              type: 'select',
              showInTable: false,
              span: 12,
              required: true,
              dicData: []
            },
            {
              prop: 'dkfs',
              label: '打开方式',
              isSearchCondition: false,
              type: 'select',
              showInTable: false,
              span: 12,
              required: true,
              dicData: []
            },
            {
              prop: 'icons',
              label: '图标',
              isSearchCondition: false,
              showInTable: false,
              span: 24,
              formslot: true
            },
            {
              prop: 'uploadTb',
              label: '上传图标',
              formslot: true,
              isSearchCondition: false,
              type: 'file',
              showInTable: false,
              span: 24
            },
            {
              prop: 'zxdh',
              label: '咨询电话',
              isSearchCondition: false,
              type: 'input',
              showInTable: false,
              span: 12
            },
            {
              prop: 'ssbm',
              label: '所属部门',
              slotName: 'ssbmForm',
              isSearchCondition: false,
              type: 'organ',
              showInTable: false,
              span: 12,
              required: true,
              max: 1,
              component: 'universalSelector',
              dicData: []
            },
            {
              prop: 'fwdx',
              label: '服务对象',
              isSearchCondition: false,
              type: 'role',
              showInTable: false,
              span: 24,
              required: true,
              max: 50,
              component: 'universalSelector',
              dicData: []
            },
            {
              prop: 'sfqy',
              label: '是否启用',
              slotName: 'sfqyForm',
              isSearchCondition: false,
              type: 'select',
              showInTable: true,
              span: 12,
              required: true,
              dicData: [
                {
                  value: '1',
                  label: '是'
                },
                {
                  value: '2',
                  label: '否'
                }
              ]
            },
            {
              prop: 'isLogin',
              label: '是否登录',
              isSearchCondition: false,
              type: 'select',
              showInTable: false,
              span: 12,
              required: true,
              dicData: [
                {
                  value: '1',
                  label: '是'
                },
                {
                  value: '2',
                  label: '否'
                }
              ]
            },
            {
              prop: 'syxs',
              label: '是否首页显示',
              isSearchCondition: false,
              type: 'select',
              showInTable: false,
              span: 12,
              required: true,
              dicData: [
                {
                  value: '1',
                  label: '是'
                },
                {
                  value: '2',
                  label: '否'
                }
              ]
            },
            {
              prop: 'sfxsjj',
              label: '是否显示简介',
              isSearchCondition: false,
              type: 'select',
              showInTable: false,
              span: 12,
              required: true,
              dicData: [
                {
                  value: '1',
                  label: '是'
                },
                {
                  value: '2',
                  label: '否'
                }
              ]
            },
            {
              prop: 'fztj',
              label: '分组推荐',
              isSearchCondition: false,
              type: 'role',
              showInTable: false,
              span: 24,
              max: 50,
              component: 'universalSelector',
              slotName: 'fztjForm'
            },
            {
              prop: 'llcs',
              label: '浏览次数',
              isSearchCondition: false,
              type: 'input',
              showInTable: false,
              span: 12,
              disabled: [true, true, true]
            },
            {
              prop: 'score',
              label: '平均评分',
              isSearchCondition: false,
              type: 'input',
              showInTable: false,
              span: 12,
              disabled: [true, true, true]
            },
            {
              prop: 'sycs',
              label: '使用次数',
              isSearchCondition: false,
              type: 'input',
              showInTable: false,
              span: 12,
              disabled: [true, true, true]
            },
            {
              prop: 'sort',
              label: '排序',
              isSearchCondition: false,
              type: 'input',
              span: 12
            },
            {
              prop: 'bz',
              label: '备注',
              isSearchCondition: false,
              type: 'textarea',
              showInTable: false,
              span: 24
            },
            {
              prop: 'yyjj',
              label: '应用简介',
              formslot: true,
              isSearchCondition: false,
              type: 'textarea',
              showInTable: false,
              span: 24
            },
            {
              prop: 'zyzid',
              label: '资源组id',
              isSearchCondition: false,
              type: 'input',
              showInTable: false,
              span: 24,
              view: [false, false, false]
            },
            {
              prop: 'zyid',
              label: '资源id',
              isSearchCondition: false,
              type: 'input',
              showInTable: false,
              span: 24,
              view: [false, false, false]
            }
          ],
          operation: {
            width: '160',
            operations: []
          },
          tableData: [],
          paging: {
            currentPage: 1,
            pageSizes: [10, 15, 20, 25],
            pageSize: 10,
            total: 0
          },
          reload: 'reloadTable',
          reloadConditions: {},
          addDefultValue: {}
        }
      }
    }
  },
  methods: {
    // 文件
    handleFileSuccess(file, fileUniqueCode) {
      file = this.fileName
      let fileNameLength = file.length
      // 插入链接
      let quill = this.$refs.QuillEditor.quill
      let length = quill.getSelection().index
      quill.insertEmbed(
        length,
        'link',
        {
          href: this.fileName + '&' + fileUniqueCode,
          innerText: file,
          fileCode: fileUniqueCode
        },
        'api'
      )
      // API_CONFIG.FDFS_WEB_SERVER_URL + res
      quill.setSelection(length + fileNameLength)
      this.loading = false
    },

    toUploadEnclosure: function (event) {
      this.file = event.target.files[0] // 获取文件
      this.fileName = this.file.name
      var windowURL = window.URL || window.webkitURL
      if (event.target.files[0]) {
        this.src = windowURL.createObjectURL(event.target.files[0])
      }
      let formData = new window.FormData() // vue 中使用 window.FormData(),否则会报 'FormData isn't definded'
      formData.append('file', this.file)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.loading = true
      this.$http
        .post('/common/document/upload', formData, config)
        .then((res) => {
          this.handleFileSuccess('fileName', res.data)
          this.$message.success('文件上传成功')
        })
        .catch((error) => {
          this.loading = false
          this.$message.error(error.msg)
        })
    },
    mainTableReload: function (params) {
      this.mainTable.table.loading = true
      this.$http
        .post('/sysApp/query', { entity: {}, orderItemList: [] }, { params })
        .then((response) => {
          this.zyID = response.data.records[0].zyid
          this.zyzID = response.data.records[0].zyzid
          this.mainTable.table.loading = false
          // 成功之后的数据
          this.mainTable.table.tableData = response.data.records
          this.mainTable.table.paging.total =
            response.data.total || response.data.records.length
        })
        .catch((error) => {
          this.mainTable.table.loading = false
          this.$message.error(error.msg)
        })
    },
    reloadTable: function (row, errorDone) {
      let params = { pageNum: row.pageNum, pageSize: row.pageSize }
      delete row['pageSize']
      delete row['pageNum']
      let rowArr = {
        entity: row,
        orderItemList: []
      }
      this.$http
        .post('/sysApp/query', rowArr, { params })
        .then((response) => {
          this.mainTable.table.loading = false
          this.mainTable.table.tableData = response.data.records
          this.mainTable.table.paging.total =
            response.data.total || response.data.records.length
          return true
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },

    handleExceed: function () {
      this.$message.warning('请移除当前图片再进行上传！')
    },
    getUser: function () {
      this.userInfo = RESOURSE_CONFIG.APPLICATION_APPKEY
    },
    editRow: function (row, done, errorDone, note, setting, oldData) {
      let id = row.id
      let that = this
      let fztjVal = ''
      let fztjArray = []
      let ssbmArray = []
      let fwdxVal = ''
      let fwdxArray = []
      row.fwdx = row.fwdx.map((item) => item.id).join(',')
      row.ssbm = row.ssbm.map((item) => item.id).join()
      if (row.fztj !== undefined) {
        row.fztj = row.fztj.map((item) => item.id).join(',')
      }
      row.yyjj = this.fwb.content
      // 分组推荐:
      if (!(row.fztj == null)) {
        row.fztj.split(',').forEach(function (currentValue, index, arr) {
          fztjVal = currentValue
          that.fztjResult.forEach(function (val, i) {
            if (fztjVal === val.value) {
              val.name = val.label
              val.id = val.value
              fztjArray.push(val)
            }
          })
        })
        row.fztj = fztjArray
      }

      // 所属部门
      that.ssbmResult.forEach(function (ssbmVal, i) {
        if (row.ssbm === ssbmVal.value) {
          ssbmVal.name = ssbmVal.label
          ssbmVal.id = ssbmVal.value
          ssbmArray.push(ssbmVal)
        }
      })
      row.ssbm = ssbmArray
      // 服务对象
      that.$http
        .get('/sysApp/get', {
          params: {
            appKey: that.userInfo,
            id: id
          }
        })
        .then((response) => {
          response.data.fwdx
            .split(',')
            .forEach(function (currentValue, index, arr) {
              fwdxVal = currentValue
              that.fwdxResult.forEach(function (val, i) {
                if (fwdxVal === val.value) {
                  val.name = val.label
                  val.id = val.value
                  fwdxArray.push(val)
                }
              })
            })
          row.fwdx = fwdxArray
        })
        .catch((error) => {
          that.$message.error(error.msg)
        })
      row.ssbm = row.ssbm.map((item) => item.id).join()
      if (row.fztj !== undefined) {
        row.fztj = row.fztj.map((item) => item.id).join(',')
      }
      row.pcUrl = this.$refs.pcUrlInput.value
      if (
        (row.pcUrl === undefined || row.pcUrl == null || row.pcUrl === '') &&
        (row.sjUrl === undefined || row.sjUrl == null || row.sjUrl === '')
      ) {
        this.$message.warning(
          '如果新增pc端应用，请填写pc端URL；如果新增手机端应用，请填写手机端URL'
        )
        errorDone()
        this.$refs.pcUrlInput.focus()
        return false
      }
      row.icons = this.icons
      this.$http
        .post('/sysApp/update', row, { params: { appKey: this.userInfo } })
        .then((response) => {
          this.$message.success('保存成功') && done()
          this.reloadTable(this.$refs.mainTable.getReloadConditions())
        })
        .catch((error) => {
          this.$message.error(error.msg) && errorDone()
        })
    },
    beforeEditFunctionName: function (row, type, callback) {
      this.readonly = false
      let id = row.id
      let that = this
      let fztjVal = ''
      let fztjArray = []
      let ssbmArray = []
      let fwdxVal = ''
      let fwdxArray = []
      this.fwb.content = row.yyjj
      // 分组推荐:
      if (!(row.fztj == null)) {
        row.fztj.split(',').forEach(function (currentValue, index, arr) {
          fztjVal = currentValue
          that.fztjResult.forEach(function (val, i) {
            if (fztjVal === val.value) {
              val.name = val.label
              val.id = val.value
              fztjArray.push(val)
            }
          })
        })
        row.fztj = fztjArray
      } else {
        row.fztj = []
      }

      // 所属部门
      that.ssbmResult.forEach(function (ssbmVal, i) {
        if (row.ssbm === ssbmVal.value) {
          ssbmVal.name = ssbmVal.label
          ssbmVal.id = ssbmVal.value
          // delete ssbmVal['label']
          // delete ssbmVal['value']
          ssbmArray.push(ssbmVal)
        }
      })
      row.ssbm = ssbmArray
      // 服务对象
      that.$http
        .get('/sysApp/get', {
          params: {
            appKey: that.userInfo,
            id: id
          }
        })
        .then((response) => {
          response.data.fwdx
            .split(',')
            .forEach(function (currentValue, index, arr) {
              fwdxVal = currentValue
              that.fwdxResult.forEach(function (val, i) {
                if (fwdxVal === val.value) {
                  val.name = val.label
                  val.id = val.value
                  fwdxArray.push(val)
                }
              })
            })
          row.fwdx = fwdxArray

          if (response.data.icons == null) {
            that.tbSrc = ''
            callback(row)
            return false
          }
          this.icons = response.data.icons
          that.tbSrc = window.config.FDFS_WEB_SERVER_URL + response.data.icons
          callback(row)
        })
        .catch((error) => {
          that.$message.error(error.msg)
        })
    },

    beforeViewFunctionName: function (row, type, callback) {
      this.readonly = true
      this.fwb.content = row.yyjj
      let that = this
      let fztjVal = ''
      let fztjArray = []
      let ssbmArray = []
      let fwdxVal = ''
      let fwdxArray = []

      this.fwb.content = row.yyjj

      // 分组推荐:
      if (!(row.fztj == null)) {
        row.fztj.split(',').forEach(function (currentValue, index, arr) {
          fztjVal = currentValue
          that.fztjResult.forEach(function (val, i) {
            if (fztjVal === val.value) {
              val.name = val.label
              val.id = val.value
              fztjArray.push(val)
            }
          })
        })
        row.fztj = fztjArray
      } else {
        row.fztj = []
      }

      // 所属部门
      that.ssbmResult.forEach(function (ssbmVal, i) {
        if (row.ssbm === ssbmVal.value) {
          ssbmVal.name = ssbmVal.label
          ssbmVal.id = ssbmVal.value
          ssbmArray.push(ssbmVal)
        }
      })
      row.ssbm = ssbmArray

      this.$http
        .get('/sysApp/get', {
          params: {
            appKey: this.userInfo,
            id: row.id
          }
        })
        .then((response) => {
          response.data.fwdx
            .split(',')
            .forEach(function (currentValue, index, arr) {
              fwdxVal = currentValue
              that.fwdxResult.forEach(function (val, i) {
                if (fwdxVal === val.value) {
                  val.name = val.label
                  val.id = val.value
                  fwdxArray.push(val)
                }
              })
            })
          row.fwdx = fwdxArray
          if (response.data.icons == null) {
            this.tbSrc = ''
            callback(row)
            return false
          }
          that.tbSrc = window.config.FDFS_WEB_SERVER_URL + response.data.icons
          this.icons = response.data.icons
          callback(row)
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },
    beforeAddFunctionName: function (row, type, callback) {
      this.readonly = false
      this.fwb.content = ''
      callback({ sfxsjj: '1', syxs: '1', isLogin: '1', sfqy: '1' })
    },
    addRow: function (row, done, errorDone) {
      row.zyzid = this.zyzID
      row.zyid = this.zyID
      row.id = null
      row.yyjj = this.fwb.content
      row.fwdx = row.fwdx.map((item) => item.id).join(',')
      row.ssbm = row.ssbm.map((item) => item.id).join()
      if (row.fztj !== undefined) {
        row.fztj = row.fztj.map((item) => item.id).join(',')
      }
      row.pcUrl = this.$refs.pcUrlInput.value
      if (
        (row.pcUrl === undefined || row.pcUrl == null || row.pcUrl === '') &&
        (row.sjUrl === undefined || row.sjUrl == null || row.sjUrl === '')
      ) {
        this.$message.warning(
          '如果新增pc端应用，请填写pc端URL；如果新增手机端应用，请填写手机端URL'
        )
        errorDone()
        this.$refs.pcUrlInput.focus()
        return false
      }
      row.icons = this.icons
      this.$http
        .post('/sysApp/save', row, { params: { appKey: this.userInfo } })
        .then((response) => {
          this.$message.success('新增成功') && done()
          this.reloadTable(this.$refs.mainTable.getReloadConditions())
        })
        .catch((error) => {
          this.$message.error(error.msg) && errorDone()
        })
    },
    getSsbm: function () {
      this.$http
        .post('/org/list', {
          entity: {},
          orderItemList: []
        })
        .then((response) => {
          this.ssbmData = response.data
          let result = []
          response.data.forEach((element) => {
            result.push({
              label: element.name,
              value: element.id
            })
          })
          this.ssbmResult = result
          this.$refs.mainTable.setColumnSeting('ssbm', 'dicData', result)
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },
    getFztj: function () {
      this.$http
        .post('/role/list', {
          entity: {},
          orderItemList: []
        })
        .then((response) => {
          let result = []
          response.data.forEach((element) => {
            result.push({
              label: element.name,
              value: element.id
            })
          })
          this.fztjResult = result
          this.$refs.mainTable.setColumnSeting('fztj', 'dicData', result)

          // this.$refs.mainTable.setColumnSeting('fwdx', 'dicData', result)
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },

    getJZFS: function () {
      this.$http
        .get('/pub/dm-const/listByCataCode', {
          params: {
            cataCode: 'JZFS'
          }
        })
        .then((response) => {
          let result = []
          response.data.forEach((element) => {
            result.push({
              label: element.label,
              value: element.value
            })
          })
          this.$refs.mainTable.setColumnSeting('jzfs', 'dicData', result)
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },

    getYYLX: function () {
      this.$http
        .get('/pub/dm-const/listByCataCode', {
          params: {
            cataCode: 'APP_TYPE'
          }
        })
        .then((response) => {
          let result = []
          response.data.forEach((element) => {
            result.push({
              label: element.label,
              value: element.value
            })
          })
          this.yylxResult = result
          this.$refs.mainTable.setColumnSeting('yylx', 'dicData', result)
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },

    getDKFS: function () {
      this.$http
        .get('/pub/dm-const/listByCataCode', {
          params: {
            cataCode: 'DKFS'
          }
        })
        .then((response) => {
          let result = []
          response.data.forEach((element) => {
            result.push({
              label: element.label,
              value: element.value
            })
          })
          this.$refs.mainTable.setColumnSeting('dkfs', 'dicData', result)
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },
    getSSFL: function () {
      this.$http
        .get('/pub/dm-const/listByCataCode', {
          params: {
            cataCode: 'APP_CLASSIFY'
          }
        })
        .then((response) => {
          this.objData = response.data
          let result = []
          response.data.forEach((element) => {
            result.push({
              label: element.label,
              value: element.value
            })
          })
          this.$refs.mainTable.setColumnSeting('ssfl', 'dicData', result)
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },
    getYYFL: function () {
      this.$http
        .get('/pub/dm-const/listByCataCode', {
          params: {
            cataCode: 'YYFL'
          }
        })
        .then((response) => {
          let result = []
          this.yyflResult = response.data
          response.data.forEach((element) => {
            result.push({
              label: element.label,
              value: element.value
            })
          })
          console.log(result)
          this.$refs.mainTable.setColumnSeting('yyfl', 'dicData', result)
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },
    getBLFS: function () {
      this.$http
        .get('/pub/dm-const/listByCataCode', {
          params: {
            cataCode: 'BLFS'
          }
        })
        .then((response) => {
          this.blfsData = response.data
          let result = []
          response.data.forEach((element) => {
            result.push({
              label: element.label,
              value: element.value
            })
          })
          this.$refs.mainTable.setColumnSeting('blfs', 'dicData', result)
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },
    getFWDX: function () {
      this.$http
        .post('/role/list', {
          entity: {},
          orderItemList: []
        })
        .then((response) => {
          let result = []
          response.data.forEach((element) => {
            result.push({
              label: element.name,
              value: element.id
            })
          })
          this.fwdxResult = result
          // this.$refs.mainTable.setColumnSeting('fwdx', 'dicData', result)
        })
        .catch((error) => {
          this.$message.error(error.msg)
          this.tbSrc = ''
        })
    },
    toUploadFile: function (event) {
      this.file = event.target.files[0] // 获取文件
      var windowURL = window.URL || window.webkitURL
      if (event.target.files[0]) {
        this.src = windowURL.createObjectURL(event.target.files[0])
      }
      let formData = new window.FormData() // vue 中使用 window.FormData(),否则会报 'FormData isn't definded'
      formData.append('file', this.file)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      formData.append('returnEntity', true)
      this.$http
        .post('/common/document/upload', formData, config)
        .then((res) => {
          this.tbSrc =
            window.config.FDFS_WEB_SERVER_URL +
            res.data.fastDFSGroupName +
            '/' +
            res.data.fastDFSPath
          this.icons = res.data.fastDFSGroupName + '/' + res.data.fastDFSPath
          this.$message.success('图片上传成功')
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },

    deleteRows: function (deleteList) {
      this.$http
        .delete('/sysApp/delete', {
          params: {
            id: deleteList.map((item) => item.id),
            appKey: this.userInfo
          }
        })
        .then((response) => {
          this.$message.success('删除成功')
          this.mainTableReload(this.$refs.mainTable.getReloadConditions())
        })
        .catch((error) => {
          this.$message.error(response.msg)
        })
    },
    appNameChange: function (appName, data) {
      this.$http
        .get('/sysApp/getFirstLettersUp', {
          params: {
            strVal: appName
          }
        })
        .then((response) => {
          data.ywsx = response.data
          this.$forceUpdate()
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    }
  },
  mounted() {
    /* 列表渲染*/
    this.mainTableReload({ pageNum: 1, pageSize: 10 })

    /* 所属部门*/
    this.getSsbm()
    /* 分组推荐*/
    this.getFztj()
    /* 加载方式*/
    this.getJZFS()
    /* 打开方式*/
    this.getDKFS()
    /* 应用类型*/
    this.getSSFL()
    /* 应用分类*/
    this.getYYFL()
    /* 办理方式*/
    this.getBLFS()
    /* 服务对象*/
    this.getFWDX()
    this.getYYLX()
    this.getUser()
    // this.addQuillTitle()
  }
}
</script>

<style lang='scss'>
.el-form-item__label {
  white-space: nowrap;
}
</style>
<style lang='scss' scoped>
.el-upload {
  display: none;
}

.tbImg {
  width: 80px;
  height: 80px;
  margin-bottom: 15px;
  float: left;
}

:deep(.ql-upload) {
  background: url(/base/images/layout/upload.jpg) !important;
  background-size: 16px 16px !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
}

:deep(.ql-tooltip) {
  left: 0 !important;
}

:deep(.ql-tooltip) {
  display: none;
}
</style>
